<template>
  <filter-summary
    icon="option"
    title="オプション"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div>{{ evaluationsLabel }}</div>
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 「オプション」の目次
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    evaluations: {
      type: Array,
      default: () => [],
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
      }
    },
    evaluationsLabel() {
      const labels = this.$store.state.labels.evaluationsPos
      let l = []

      for (const e of this.evaluations) {
        l.push(labels[e])
      }

      return l.join('、')
    },
  },
}
</script>
